var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "custom-audio",
      class: _vm.disabled ? "disabled" : "",
      attrs: { onselectstart: "return false" },
    },
    [
      _vm.isPaused
        ? _c("i", {
            staticClass: "el-icon-video-pause",
            on: { click: _vm.playAudio },
          })
        : _c("i", {
            staticClass: "el-icon-caret-right",
            on: { click: _vm.playAudio },
          }),
      _c("span", { staticClass: "time" }, [_vm._v(_vm._s(_vm.time))]),
      _c(
        "div",
        {
          ref: "audioProgress",
          staticClass: "audio-progress",
          on: {
            mousedown: function ($event) {
              return _vm.controlAudioProgress($event)
            },
          },
        },
        [_c("span", { staticClass: "bar", style: _vm.progressStyle })]
      ),
      _c("span", { staticClass: "time" }, [_vm._v(_vm._s(_vm.duration))]),
      _c("svg-icon", {
        staticClass: "audio-download",
        attrs: { "icon-class": "download" },
        on: { click: _vm.downloadAudio },
      }),
      !_vm.isCustom
        ? _c(
            "el-dropdown",
            { attrs: { placement: "top" } },
            [
              _c("span", { staticClass: "ml-10 speed" }, [
                _vm._v(
                  _vm._s(
                    _vm.multipleIndex == null || _vm.multipleIndex == 2
                      ? "倍速"
                      : _vm.multipleArray[_vm.multipleIndex] + "X"
                  )
                ),
              ]),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                _vm._l(_vm.multipleArray, function (item, index) {
                  return _c(
                    "el-dropdown-item",
                    {
                      key: index,
                      class: _vm.multipleIndex == index ? "active" : "",
                      nativeOn: {
                        click: function ($event) {
                          return _vm.changeMultiple(index)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item) + "x")]
                  )
                }),
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass: "speed-wrap",
              on: {
                mouseenter: function ($event) {
                  _vm.isShow = true
                },
                mouseleave: function ($event) {
                  _vm.isShow = false
                },
              },
            },
            [
              _c(
                "ul",
                {
                  staticClass: "el-dropdown-menu el-popper",
                  style: { display: _vm.isShow ? "" : "none" },
                },
                [
                  _vm._l(_vm.multipleArray, function (item, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        staticClass: "el-dropdown-menu__item",
                        class: _vm.multipleIndex == index ? "active" : "",
                        on: {
                          click: function ($event) {
                            return _vm.changeMultiple(index)
                          },
                        },
                      },
                      [_vm._v(_vm._s(item) + "x")]
                    )
                  }),
                  _c("div", {
                    staticClass: "popper__arrow",
                    staticStyle: { left: "26.5px" },
                  }),
                ],
                2
              ),
              _c("span", { staticClass: "ml-10 speed" }, [
                _vm._v(
                  _vm._s(
                    _vm.multipleIndex == null || _vm.multipleIndex == 2
                      ? "倍速"
                      : _vm.multipleArray[_vm.multipleIndex] + "X"
                  )
                ),
              ]),
            ]
          ),
      _c("audio", {
        ref: "recordAudio",
        staticClass: "recordAudio",
        attrs: { type: "audio/mpeg", src: _vm.audioUrl },
        on: {
          canplay: _vm.canPlay,
          timeupdate: _vm.timeUpdate,
          ended: _vm.onEnded,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }